<template>

  <div class="container mx-auto px-4">
    <div class="sm:px-4 pt-24 pb-20">
      <Sidebar></Sidebar>
      <Header>{{ menuItem}} - {{classe}}
        <Count
          :total="totalChildren"
          v-if="menuItem === `${$t('all.kids_in_class')}`"
        >
          <div slot="left">
            <p class="text-green text-xs">{{ present }} {{$t('all.class_present')}}</p>
          </div>
          <div slot="right">
            <p class="text-xs text-blue-dark"> {{ leftChildren }} {{$t('all.common_left')}}</p>
          </div>
        </Count>
        <Count
          :total="totalChildren"
          v-if="menuItem === `${$t('all.class_appeal')}`"
        >
          <div slot="left">
            <p class="text-red text-xs"> {{ withAlarm }} {{$t('all.common_with_alarm')}}</p>
          </div>
          <div slot="right">
            <p class="text-xs text-blue-dark"> {{ withoutAppeal }} {{$t('all.common_without_appeal')}} </p>
          </div>
        </Count>
        <Count
          :total="totalChildren"
          v-if="menuItem === `${$t('all.kids_list')}`">
          <div slot="left">
            <p class="text-red text-xs">{{ withAlarm }} {{$t('all.common_with_alarm')}}</p>
          </div>
          <div slot="right">
            <p class="text-xs text-blue-dark"> {{ leftChildren }} {{$t('all.common_left')}} </p>
          </div>
        </Count>
      </Header>
      <Minore
        :menuItem="menuItem"
        v-for="minor in minors"
        :minor="minor"
        :key="minor.id"
      >
        <div slot="role">{{$t('all.parent')}}</div>
      </Minore>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import menuItemList from '@/utils/constants';
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import values from 'lodash/values';

export default {
  data() {
    return {
      menuItem: '',
      classe: '',
      countWithAlarm: ['minor_max_danger', 'minor_danger', 'minor_warning'],
    };
  },
  computed: {
    ...mapGetters({
      listOfChildren: 'users/listOfChildren',
      childrenCount: 'users/childrenCount',
    }),
    present() {
      return this.childrenCount.minor_in_class || 0;
    },
    leftChildren() {
      return this.childrenCount.minor_left_class || 0;
    },
    withAlarm() {
      let total = 0;
      if (this.listOfChildren) {
        const minorCount = this.childrenCount;
        this.countWithAlarm.forEach((minorLeft) => {
          total += minorCount[minorLeft] || 0;
        });
      }
      return total;
    },
    withoutAppeal() {
      return this.listOfChildren.length || 0;
    },
    totalChildren() {
      return this.childrenCount.total || 0;
    },
    minors() {
      if (this.menuItem === `${this.$t('all.kids_list')}`) {
        return orderBy(this.listOfChildren, ['surname'], ['asc']);
      }
      if (
        this.menuItem === `${this.$t('all.class_appeal')}` ||
        this.menuItem === `${this.$t('all.kids_in_class')}`
      ) {
        return orderBy(values(this.listOfChildren), ['time_limit'], ['asc']);
      }
      return this.listOfChildren;
    },
  },
  methods: {
    ...mapActions('users', [
      'getAllByClass',
      'getRollCallByClass',
      'getChildrenInClass',
    ]),
    updateMinors() {
      if (this.menuItem === `${this.$t('all.kids_list')}`) {
        this.getAllByClass({
          id: this.$route.params.id,
        });
      }
      if (this.menuItem === `${this.$t('all.class_appeal')}`) {
        this.getRollCallByClass({
          id: this.$route.params.id,
        });
      }
      if (this.menuItem === `${this.$t('all.kids_in_class')}`) {
        this.getChildrenInClass({
          id: this.$route.params.id,
        });
      }
    },
  },
  created() {
    const _this = this;
    this.classe = this.$route.query.classe;
    this.menuItem = this.$route.query.menuItem;
   _this.updateMinors();
    setInterval(() => {
      _this.updateMinors();
    }, 3000);
  },
};
</script>
